import styled from 'styled-components';
import { notificationBar } from 'syf-component-library/defaultTheme';
import { MessageBox } from 'syf-component-library/ui/patterns';
const borderColors = {
    success: notificationBar.success.badgeBackground,
    warning: notificationBar.warning.badgeBackground,
    info: notificationBar.info.badgeBackground,
    error: notificationBar.error.badgeBackground
};
const backgroundColors = {
    success: notificationBar.success.background,
    warning: notificationBar.warning.background,
    info: notificationBar.info.background,
    error: notificationBar.error.background
};
export const MessageBoxSyf = styled(MessageBox) `
  border-width: 2px;
  border-color: ${({ type }) => borderColors[type]};
  background-color: ${({ type }) => backgroundColors[type]};
`;
